import React from 'react';
import HeroBanner from './components/Home/HeroBanner';
import LatestNews from './components/Home/LatestNews';
import CategoryGrid from './components/Home/CategoryGrid';
import Notification from './components/Home/Notification';
import CampusLife from './components/Home/CampusLife';
import QuickLinks from './components/Home/QuickLinks';
import AchievementSlider from './components/Home/AchievementSlider';
import Counter from './components/Home/Counter';
import SocialMedia from './components/Home/SocialMedia';
import YoutubeVideo from './components/Home/YoutubeVideo';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const Home = () => {
  return (
    <div>
      <HeroBanner />
      <LatestNews />
      <CategoryGrid />
      <Notification />
      <CampusLife />
      <QuickLinks />
      <AchievementSlider />
      <Counter />
      <SocialMedia />
      <YoutubeVideo />
      <ImportantLinksSlider />
    </div>
  )
}

export default Home;